module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("I would like to dedicate this book to all my patients and"), _c('br'), _vm._v(" readers and to members of my "), _c('a', {
    attrs: {
      "href": "http://Self-Coaching.net",
      "target": "_blank"
    }
  }, [_vm._v("Self-Coaching.net")]), _vm._v(" community."), _c('br'), _vm._v(" You have been my inspiration, my encouragement, and my"), _c('br'), _vm._v(" motivation to continue on my path.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e2c757","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/luci_9780470893708_oeb_ded_r1.vue
// module id = 66
// module chunks = 0